import { render } from "./CarComponent.vue?vue&type=template&id=255a2fd3&scoped=true"
import script from "./CarComponent.vue?vue&type=script&lang=js"
export * from "./CarComponent.vue?vue&type=script&lang=js"

import "./CarComponent.vue?vue&type=style&index=0&id=255a2fd3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255a2fd3"]])

export default __exports__